module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lista.length) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered table-striped b-t b-light",
    staticStyle: {
      "border-top": "1px solid #eaeff0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.loading) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Carregando...")])]) : _vm._l((_vm.lista), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "scope": "row",
        "role": "button",
        "tabindex": "0"
      }
    }, [_vm._v("\n        " + _vm._s(_vm.formatarData(item.storageCreatedAt)) + "\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row",
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('button', {
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.download(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Visualizar arquivo\n        ")])])])
  })], 2)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Cadastrado em")]), _vm._v(" "), _c('th', [_vm._v("Arquivo")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a463442","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/policia-civil/roubo-furto/components/ListaArquivosNotificacoesGrv.vue
// module id = 1501
// module chunks = 17